import { useNavigate } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { goToLink } from '../../projectData';

/**
 * AddressList component displays a list of user addresses for selection or addition.
 * Handles address rendering, selection, and navigation to add new address.
 */
export const AddressList = ({ addressArray, selectedItem, user_code }) => {
    const navigate = useNavigate()
    return (
        <>
            <div className='container'>

                <div style={{ background: '#fefafa' }} className='card mt-3 mb-4'>
                    <div className='card-body p-4'>
                        <div className='fs-5'>Please select Address or if you want add new address</div>
                    </div>
                </div>
                <div className="row mt-4">
                    {Array.isArray(addressArray) && addressArray.length > 0 ?
                        addressArray.map((item, index) => (
                            <div onClick={() => goToLink(navigate, `/customer/redem-detail/re-confirm/${user_code}`, { itemValue: selectedItem, detailData: item })} key={index} className="col-sm-4 mb-4">
                                <div
                                    style={{ border: '1px solid #E6E6E6', borderRadius: '15px', }}
                                    className="card p-4 position-relative"
                                >
                                    <div className="card-title m-0 d-flex align-items-center gap-4">
                                        <div
                                            className="symbol d-flex align-items-center justify-content-center position-relative"
                                            style={{
                                                width: '45px',
                                                height: '45px',
                                                borderRadius: '50%',
                                                border: `2px solid ${Number(item?.status) === 1 ? '#28a745' : '#828282'}`, // Green for verified, gray otherwise
                                            }}
                                        >
                                            {item?.address_type?.toLowerCase() === 'home' ? (
                                                <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-home.png')} alt='redem-home' />
                                            ) : (item?.address_type?.toLowerCase() === 'other' ? (
                                                <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-other.png')} className='redem-other' alt='redem-other' />) :
                                                <>
                                                    <img style={{ width: '20px', height: "20px" }} src={toAbsoluteUrl('/media/images/redem-office.png')} className='redem-office' alt='redem-ofice' />
                                                </>
                                            )}

                                            {/* Checkmark for verified addresses */}

                                            <i
                                                className="bi bi-check-circle-fill position-absolute"
                                                style={{
                                                    fontSize: '13px',
                                                    top: '-1px',
                                                    right: '-1px',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '50%',
                                                    color: Number(item?.status) === 1 ? '#28a745' : '#828282',
                                                }}
                                            ></i>

                                        </div>




                                        <button
                                            type="button"
                                            className="btn btn-link fs-3 fw-semibold text-black text-capitalize text-decoration-none"
                                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                            aria-label={`Address type: ${item?.address_type}`}
                                        >
                                            {item?.address_type}
                                        </button>
                                        {/* {item?.address_status_id === 1 ? (
                                                        <i className="bi bi-patch-check-fill fs-4 text-success ms-2"></i>
                                                    ) : (
                                                        <i className="bi text-warning bi-exclamation-triangle ms-2 fs-4"></i>
                                                    )} */}
                                    </div>
                                    <div className="card-body p-2 ps-0 row">
                                        <div className="col-10">
                                            <p className="fs-6 ms-2 m-0 mt-2">
                                                {item?.address1 && `${item.address1},`}
                                                {item?.address2 && `${item.address2}`}
                                                {(item?.address1 || item.address2) && <br />}
                                                {item?.address3 && `${item.address3}, `}
                                                {item?.landmark && `${item.landmark}`}
                                                {(item?.address3 || item.landmark) && <br />}
                                                {item?.city && `${item.city}, `}
                                                {item?.district && `${item.district}, `}
                                                {item?.state && `${item.state}, `}
                                                {item?.pincode && `${item.pincode}`}
                                            </p>
                                        </div>
                                        {item.address_status_id !== 1 && (
                                            <div className="col-2 p-0 d-flex align-items-center">

                                                <div className=""
                                                // onClick={() => editAddress(item)}
                                                >
                                                    <i className="bi bi-chevron-right fs-1 ms-4 link-primary"></i>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/* {item.address_type === 'Home' && (
                                        <div style={{
                                            borderBottomLeftRadius: '20px',
                                            backgroundColor: "#828282",
                                            borderTopRightRadius: '10px'
                                        }}
                                            className="position-absolute top-0 end-0 p-1 "
                                        >
                                            <span className="ms-4 text-white">Default Address</span>
                                        </div>
                                    )} */}
                                </div>
                            </div>
                        ))
                        : <div style={{ background: '#fefafa' }} className='card mt-3 mb-4'>
                            <div className='card-body p-4'> <div className="notice d-flex bg-light-danger rounded border-primary border border-dashed mt-5 mb-9 p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger' />
                                </span>
                                <div className="d-flex flex-stack flex-grow-1">
                                    <div className="fw-semibold">
                                        <div className="fs-6 text-gray-700 gap-3 ">No addrees found plaese add where you want dispatch, please note your address slef verified
                                            {/* <Link to="/customer/dashboard" className="fw-semibold"> Back</Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            {/* Sticky Button */}
            <div onClick={() => goToLink(navigate, `/customer/redem-detail/add-address/${user_code}`, { itemValue: selectedItem })} className="col-sm-2   sticky-bottom">

                <div className='p-7 rounded-5' style={{ backgroundColor: "white", width: '100%', }}>
                    <button className="btn btn-danger w-100 ">Add New Address</button>
                </div>
            </div>


        </>
    )
}
